import { Typography } from 'antd';
import { FC } from 'react';
import styled from 'styled-components';

import { MenuItem } from 'src/features/layout/hooks/useSideMenuItems';

interface LastAccessedItemProps {
  item: MenuItem;
}

const { Text } = Typography;

export const LastAccessedItem: FC<LastAccessedItemProps> = ({ item }) => {
  return (
    <Item onClick={() => item.onClick?.()}>
      {item.icon}
      <Text
        style={{
          fontSize: '14px',
          fontWeight: 600,
          color: '#FFFFFFD9',
        }}
      >
        {item.label}
      </Text>
    </Item>
  );
};

const Item = styled.div`
  gap: 16px;
  width: 100%;
  display: flex;
  padding: 16px;
  cursor: pointer;
  border-radius: 6px;
  align-items: center;
  background-color: #1f1f1f;

  & > span:first-of-type {
    padding: 8px;
    font-size: 17.5px;
    border-radius: 6px;
    background-color: #ffffff0a;
  }
`;
